import pino from 'pino'

export type LogChannel =
  | 'lisa.genericLog'
  | 'lisa.accessLog'
  | 'lisa.uncaughtException'
  | 'lisa.unsubscribe'
  | 'lisa.sitemap'
  | 'lisa.http.carol'
  | 'lisa.http.nika'
  | 'lisa.openSearch'
  | 'lisa.recaptcha'
  | 'lisa.http.userspace'

type LogFields = {
  channel: LogChannel
}
type LogFn = (fields: LogFields, message?: string) => void
type LoggerKey = 'trace' | 'debug' | 'info' | 'error' | 'fatal' | 'silent'

const pinoLogger: Omit<pino.Logger, LoggerKey> & Record<LoggerKey, LogFn> = pino({
  base: {
    pid: process.pid,
  },
  browser: {
    asObject: true,
  },
  formatters: {
    level: (label) => ({ level: label.toUpperCase() }),
  },
  level: process.env.LISA_LOG_LEVEL || 'info',
  messageKey: 'message',
  timestamp: () => `,"datetime":"${new Date(Date.now()).toISOString()}"`,
})

export default pinoLogger
